export default __webpack_public_path__ + "static/media/2.36489098.png";